import React from 'react';

const AddAmenityModal = ({
  isOpen,
  setIsOpen,
  inputValue,
  handleInputChange,
  handleAddAmenities,
}) => {
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">Add Amenity</h2>
        <form
          className="oms-modal-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleAddAmenities();
          }}
        >
          <div className="oms-form-group">
            <label htmlFor="amenity" className="oms-form-label">Amenity</label>
            <input
              type="text"
              id="amenity"
              name="amenity"
              value={inputValue}
              onChange={handleInputChange}
              placeholder="Enter amenity"
              required
            />
          </div>

          <div className="oms-form-actions">
            <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
            <button type="submit">Add</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAmenityModal;
